import { render, staticRenderFns } from "./OptimizerTabs.vue?vue&type=template&id=91bacbfc&scoped=true"
import script from "./OptimizerTabs.vue?vue&type=script&lang=js"
export * from "./OptimizerTabs.vue?vue&type=script&lang=js"
import style0 from "./OptimizerTabs.vue?vue&type=style&index=0&id=91bacbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bacbfc",
  null
  
)

export default component.exports